import { render } from "./Attacks.vue?vue&type=template&id=6fd0f9f9"
import script from "./Attacks.vue?vue&type=script&lang=js"
export * from "./Attacks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/Attacks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fd0f9f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fd0f9f9', __exports__)) {
    api.reload('6fd0f9f9', __exports__)
  }
  
  module.hot.accept("./Attacks.vue?vue&type=template&id=6fd0f9f9", () => {
    api.rerender('6fd0f9f9', render)
  })

}


export default __exports__